import React, { lazy } from 'react';
import Loadable from 'app/components/Loadable';
import OrgLayout from './OrgLayout';

const OrgDetails = Loadable(lazy(() => import('./OrgDetails')));
const OrgSettings = Loadable(lazy(() => import('./OrgSettings')));
const OrgCreate = Loadable(lazy(() => import('./OrgCreate')));

const orgRoutes = [
  {
    path: '/org/:orgId',
    element: <OrgLayout />, // OrgLayout is provided here
    children: [
      {
        path: '', // default route: can show OrgDetails or a landing component
        element: <OrgDetails />,
      },
      {
        path: 'settings',
        element: <OrgSettings />,
      }
    ],
  },
  {
    path: '/org/create',
    element: <OrgCreate />,
  },
];

export default orgRoutes;
